import { LineMeasurementDetails } from './LineMeasurementDetails';
import { createLineMeasurementController } from './line-measurement-controller';

export const lineMeasurementConfig = {
  detailsComponent: LineMeasurementDetails,
  optionsComponent: undefined,
  createController: createLineMeasurementController,
};

export type {
  LineDetailsProps,
  LineMeasurementController,
} from './line-measurement.types';
export type { LineMeasurementDetailsProps } from './LineMeasurementDetails';
export { LineMeasurementDetails, createLineMeasurementController };
